function readScrollY(loco) {
  const lenis = loco?.lenisInstance;
  if (lenis && typeof lenis.scroll === "number") return lenis.scroll;
  return window.scrollY || document.documentElement.scrollTop || 0;
}

function readMaxScrollY() {
  return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
}

function readProgress(marquee) {
  const raw = getComputedStyle(marquee).getPropertyValue("--progress").trim();
  const value = parseFloat(raw);
  return Number.isFinite(value) ? value : 0;
}

function readUnsettleScrollY(section) {
  if (!section) return 0;
  return Math.max(0, section.offsetTop - window.innerHeight);
}

function freezeTransform(marquee) {
  const transform = getComputedStyle(marquee).transform;
  if (transform && transform !== "none") {
    marquee.style.transform = transform;
  }
}

export function initContactBand(loco) {
  const marquee = document.querySelector(".contact-band__marquee");
  if (!marquee?.hasAttribute("data-scroll-css-progress")) return;

  const section = document.getElementById("kontakt");
  let settling = false;

  const settle = () => {
    if (marquee.classList.contains("contact-band__marquee--settled") || settling) return;
    settling = true;
    requestAnimationFrame(() => {
      freezeTransform(marquee);
      marquee.classList.add("contact-band__marquee--settled");
      settling = false;
    });
  };

  const unsettle = () => {
    marquee.classList.remove("contact-band__marquee--settled");
    marquee.style.removeProperty("transform");
  };

  const update = () => {
    const scrollY = readScrollY(loco);

    if (marquee.classList.contains("contact-band__marquee--settled")) {
      if (scrollY < readUnsettleScrollY(section)) {
        unsettle();
      }
      return;
    }

    const progress = readProgress(marquee);
    const atPageEnd = scrollY >= readMaxScrollY() - 4;

    if (progress >= 1 || atPageEnd) {
      settle();
    }
  };

  if (typeof loco?.subscribeLenisScroll === "function") {
    loco.subscribeLenisScroll(update);
  } else {
    window.addEventListener("scroll", update, { passive: true });
  }

  window.addEventListener("resize", update, { passive: true });
  update();
}
